import { ERouteName } from "@/routeName";

const router: Record<ERouteName, string> = {
  [ERouteName.LOGIN]: "Connexion",
  [ERouteName.DASHBOARD]: "Dashboard",
  [ERouteName.SITE_SEARCH]: "Recherche de sites",
  [ERouteName.SITE_CREATE]: "Création de site",
  [ERouteName.SITE_DETAILS]: "Vue d'ensemble",
  [ERouteName.SITE_DETAILS_OVERVIEW]: "Vue d'ensemble",
  [ERouteName.SITE_DETAILS_GALLERY]: "Galerie",
  [ERouteName.SITE_DETAILS_DOCUMENTS]: "Documents",
  [ERouteName.SITE_DETAILS_SUPPORT]: "Support",
  [ERouteName.SITE_DETAILS_ROTATION]: "Déménagement",
  [ERouteName.SITE_DETAILS_LIVE_VX]: "Suivi du pilotage",
  [ERouteName.SITE_DETAILS_DTD]: "RIP",
  [ERouteName.SITE_DETAILS_OPERATION]: "Opération",
  [ERouteName.SITE_DETAILS_WORKING_CONDITION_MODULATIONS]: "Modulations",
  [ERouteName.SITE_DETAILS_WORKING_CONDITION_ACQUISITION]: "Acquisition",
  [ERouteName.SITE_DETAILS_SUBSCRIBER_FEEDBACK]: "Remontées adhérents",
  [ERouteName.SITE_DETAILS_SENSORS]: "Capteurs de température",
  [ERouteName.SITE_DETAILS_SUBSCRIBER_EDIT]: "Mise à jour de l'adhérent",
  [ERouteName.SITE_DETAILS_SITE_EDIT]: "Mise à jour du site",
  [ERouteName.SITE_DETAILS_APPOINTMENT]: "Rendez-vous",
  [ERouteName.SITE_DETAILS_DELIVERY_POINT]: "Point de livraison",
  [ERouteName.SITE_DETAILS_CLOSE_CALL]: "Fin d'appel",
  [ERouteName.SITE_DETAILS_ATTACH_SUBSCRIBER]: "Attacher un adhérent",
  [ERouteName.SITE_DETAILS_COMFORT]: "Pb. Confort/Technique",
  [ERouteName.SITE_DETAILS_CONSUMPTION]: "Consommation",
  [ERouteName.SITE_DETAILS_OFFERS_ELIGIBILITY]: "Offres Adhérents",
  [ERouteName.SITE_DETAILS_ELIGIBILITY_FORM]: "Eligibilité",
  [ERouteName.SITE_DETAILS_ESC_FODLER]: "Dossier CEE",
  [ERouteName.V4H_ORGANIZATION_OVERVIEW]: "Vue d'ensemble",
  [ERouteName.V4H_ORGANIZATION_SUPPORT]: "Support",
  [ERouteName.V4H_ORGANIZATION_PILOT_OVERSIGHT]: "Suivi du pilotage",
  [ERouteName.V4H_SITES_SEARCH]: "Sites Hébergement",
  [ERouteName.V4H_ORGANIZATION_DETAILS]: "Détails de l'organisation",
};

export type RouterLocale = typeof router;

const titles: Record<ERouteName, string> = {
  [ERouteName.LOGIN]: "Connexion",
  [ERouteName.DASHBOARD]: "Dashboard",
  [ERouteName.SITE_SEARCH]: "Recherche de sites",
  [ERouteName.SITE_CREATE]: "Création de site",
  [ERouteName.SITE_DETAILS]: "Vue d'ensemble",
  [ERouteName.SITE_DETAILS_OVERVIEW]: "Vue d'ensemble",
  [ERouteName.SITE_DETAILS_GALLERY]: "Galerie",
  [ERouteName.SITE_DETAILS_DOCUMENTS]: "Documents",
  [ERouteName.SITE_DETAILS_SUPPORT]: "Support",
  [ERouteName.SITE_DETAILS_ROTATION]: "Déménagement",
  [ERouteName.SITE_DETAILS_LIVE_VX]: "Suivi du pilotage",
  [ERouteName.SITE_DETAILS_DTD]: "RIP",
  [ERouteName.SITE_DETAILS_OPERATION]: "Opération",
  [ERouteName.SITE_DETAILS_WORKING_CONDITION_MODULATIONS]: "Modulations",
  [ERouteName.SITE_DETAILS_WORKING_CONDITION_ACQUISITION]: "Acquisition",
  [ERouteName.SITE_DETAILS_SUBSCRIBER_FEEDBACK]: "Remontées adhérents",
  [ERouteName.SITE_DETAILS_SENSORS]: "Capteurs de température",
  [ERouteName.SITE_DETAILS_SUBSCRIBER_EDIT]: "Mise à jour adhérent",
  [ERouteName.SITE_DETAILS_SITE_EDIT]: "Mise à jour",
  [ERouteName.SITE_DETAILS_APPOINTMENT]: "Rendez-vous",
  [ERouteName.SITE_DETAILS_DELIVERY_POINT]: "Point de livraison",
  [ERouteName.SITE_DETAILS_CLOSE_CALL]: "Fin d'appel",
  [ERouteName.SITE_DETAILS_ATTACH_SUBSCRIBER]: "Attacher un adhérent",
  [ERouteName.SITE_DETAILS_COMFORT]: "Pb. Confort/Technique",
  [ERouteName.SITE_DETAILS_CONSUMPTION]: "Consommation",
  [ERouteName.SITE_DETAILS_OFFERS_ELIGIBILITY]: "Offres Adhérents",
  [ERouteName.SITE_DETAILS_ELIGIBILITY_FORM]: "Eligibilité",
  [ERouteName.SITE_DETAILS_ESC_FODLER]: "Dossier CEE",
  [ERouteName.V4H_ORGANIZATION_OVERVIEW]: "Vue d'ensemble",
  [ERouteName.V4H_ORGANIZATION_SUPPORT]: "Support",
  [ERouteName.V4H_ORGANIZATION_PILOT_OVERSIGHT]: "Suivi du pilotage",
  [ERouteName.V4H_SITES_SEARCH]: "Sites Hébergement",
  [ERouteName.V4H_ORGANIZATION_DETAILS]: "Détails de l'organisation",
};

// Enumerate all url path parameters that :
// - are used in router declaration
// - and would like to see in the page title
const parameters = {
  siteId: "Site {siteId}",
  organizationId: "Organisation {organizationId}",
};

export type RouterI18nParameters = typeof parameters;

export default {
  router,
  routing: { titles, parameters },
};
